export default "__VITE_ASSET__d681db9c__"